import { Stack, Typography } from "@braintrust/braintrust-ui-components";
import { AccountBalanceIcon } from "@braintrust/braintrust-ui-components/Icons";
import type { PaymentMethod } from "@js/types/payments";

type PaymentMethodVendorImageProps = {
  paymentMethod: PaymentMethod;
  className?: string;
};

export const PaymentMethodVendorImage = ({
  paymentMethod,
  ...props
}: PaymentMethodVendorImageProps) => {
  switch (paymentMethod.content_type) {
    case ENUMS.PaymentContentType.StripeSepaDirectDebitPaymentMethod:
      return (
        <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
          <AccountBalanceIcon
            titleAccess={"SEPA payment method"}
            sx={{
              fontSize: { xs: "1.5rem !important", sm: "2rem !important" },
            }}
          />
          <Typography
            component="span"
            variant="paragraph"
            size="medium"
            fontWeight={500}
            sx={{
              fontSize: { xs: "0.875rem !important", sm: "1rem !important" },
            }}
          >
            SEPA
          </Typography>
        </Stack>
      );
    case ENUMS.PaymentContentType.StripeACHPaymentMethod:
      return (
        <AccountBalanceIcon
          titleAccess={"ACH payment method"}
          sx={{ fontSize: "32px" }}
        />
      );

    case ENUMS.PaymentContentType.StripeCreditCardPaymentMethod:
      return (
        <img
          alt={`${paymentMethod.method.brand || "Vendor"} Logo`}
          src={`${SETTINGS.STATIC_URL}payment-icons/${
            paymentMethod.method.brand || "default"
          }.svg`}
          className={props.className}
          width="80"
          height="50"
        />
      );

    default: {
      paymentMethod satisfies never;
      return null;
    }
  }
};
